import axios, { AxiosInstance } from 'axios'
import store from '@/store'

const api: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL
})

api.interceptors.request.use((config) => {
  const token = store.state.token || localStorage.getItem('access_token')
  if (token) {
    config.headers = config.headers ?? {}
    config.headers.Authorization = `Bearer ${token}`
  }
  const selectedOwnerId = store.state.selectedOwnerId || localStorage.getItem('selected_owner_id')
  if (selectedOwnerId) {
    config.headers = config.headers ?? {}
    config.headers['X-Owner-Id'] = selectedOwnerId
  }
  return config
})

function filenameFromDisposition (disposition?: string): string | null {
  if (!disposition) return null
  const encodedMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i)
  if (encodedMatch?.[1]) {
    return decodeURIComponent(encodedMatch[1])
  }
  const match = disposition.match(/filename="?([^";]+)"?/i)
  return match?.[1] || null
}

export async function openProtectedFile (path: string, fallbackFilename = 'archivo.pdf'): Promise<void> {
  const response = await api.get(path, {
    responseType: 'blob'
  })

  const contentType = response.headers['content-type'] || 'application/octet-stream'
  const filename = filenameFromDisposition(response.headers['content-disposition']) || fallbackFilename
  const blob = new Blob([response.data], { type: contentType })
  const objectUrl = window.URL.createObjectURL(blob)
  const opened = window.open(objectUrl, '_blank', 'noopener,noreferrer')

  if (!opened) {
    const link = document.createElement('a')
    link.href = objectUrl
    link.download = filename
    document.body.appendChild(link)
    link.click()
    link.remove()
  }

  window.setTimeout(() => {
    window.URL.revokeObjectURL(objectUrl)
  }, 60_000)
}

export default api
